import React, { useState, createContext } from "react";

const ReplyMessageContext = createContext();

// Duas coisas, um provider só: responder e EDITAR são estados da mesma caixa
// de digitar, e nunca valem ao mesmo tempo — quem entra em um limpa o outro.
// Provider separado só faria a caixa ter que ouvir dois contextos para decidir
// o que mostrar no topo dela.
const ReplyMessageProvider = ({ children }) => {
	const [replyingMessage, setReplyingMessage] = useState(null);
	const [editingMessage, setEditingMessageState] = useState(null);

	const setEditingMessage = (message) => {
		setEditingMessageState(message);
		if (message) setReplyingMessage(null);
	};

	return (
		<ReplyMessageContext.Provider
			value={{
				replyingMessage,
				setReplyingMessage,
				editingMessage,
				setEditingMessage,
			}}
		>
			{children}
		</ReplyMessageContext.Provider>
	);
};

export { ReplyMessageContext, ReplyMessageProvider };
